module.exports = __webpack_public_path__ + "static/media/cd.b070cb89.svg";